import { render } from "./LentesDeSeguridad.vue?vue&type=template&id=0005c4e1&ts=true"
import script from "./LentesDeSeguridad.vue?vue&type=script&lang=ts"
export * from "./LentesDeSeguridad.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__